import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

function PageErrorDefault(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "grey.900",
        gap: "4rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          whiteSpace: "nowrap",
        }}
      >
        <img
          alt="socket1"
          height="404px"
          src="/assets/socket1.png"
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "340px",
            flex: "1 1 30%",
            minWidth: "40px",
          }}
          width="340px"
        />
        <img
          alt="layer1"
          height="356px"
          src="/assets/layer3.png"
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "610px",
            flex: "1 1 30%",
            minWidth: "220px",
          }}
          width="610px"
        />
        <img
          alt="socket2"
          height="385px"
          src="/assets/socket2.png"
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "319px",
            flex: "1 1 30%",
            minWidth: "40px",
          }}
          width="319px"
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
          paddingInline: "1.5rem",
        }}
      >
        <Typography
          color="white.main"
          fontWeight="600"
          textAlign="center"
          variant="body1"
        >
          <KeyboardArrowLeftIcon sx={{ marginBottom: "-6px" }} /> {t("errors.weApologize")}
        </Typography>
        <Typography
          color="white.main"
          fontWeight="600"
          textAlign="center"
          variant="body1"
        >
          {t("errors.somethingWentWrong")}{" "}
          <KeyboardArrowRightIcon sx={{ marginBottom: "-6px" }} />
        </Typography>
        <Button
          color="error"
          component={Link}
          size="medium"
          sx={{ marginTop: "3rem" }}
          to="/"
          variant="outlined"
        >
          {t("errors.backToHome")}
        </Button>
      </Box>
    </Box>
  );
}

export const Route = createFileRoute("/error")({
  component: PageErrorDefault,
});
